export const CUSTOM_SEARCH_BAR = "custom-seach-bar";

export const SUGGESTIONS_NOT_FOUND = "No suggestions found ...";
export const PRODUCTS_NOT_FOUND = "Sorry! No products found ...";
export const SHOW_MORE_RESULTS = "Show more results ...";

// export const API_ORIGIN = "http://panel2.knx-group.net:8001";

export const SUGGESTIONS_FIELDS = [
  "autoname",
  "ref1",
  "ref2",
  "ref1f",
  "manufacturer",
  "manufacturer_series",
];

export const NUMBER_OF_SUGGESTIONS = 20;

export const DEFAULT_FACETS = {
  manufacturer: { type: "value", size: 250 },
  main_color: { type: "value" },
  not_discontinued: { type: "value" },
  common: { type: "value", size: 10 },
  color: { type: "value", size: 250 },
  manufacturer_series: { type: "value", size: 250 },
  lg_1: { type: "value", size: 50 },
};

export const DEFAULT_FIELDS = [
  "ref1",
  "ref1f",
  "manufacturer",
  "autoname",
  "manufacturer_series",
];
export const RESULTS_FIELDS = [
  { key: "main_family", value: 0 },
  { key: "code", value: 0 },
  { key: "image", value: 1 },
  { key: "manufacturer", value: 1 },
  { key: "reference", value: 1 },
  { key: "name", value: 1 },
  { key: "net_price", value: 1 },
  { key: "pvp_neto", value: 0 },
  { key: "list_price", value: 0 },
  { key: "stock", value: 0 },
];

export const MAIN_FAMILY = "main_family";
export const IMAGE = "image";
export const PRODUCT_IMAGE = "product_img";
export const CODE = "code";
export const MANUFACTURER = "manufacturer";
export const REFERENCE = "reference";
export const NAME = "name";
export const PVP_NETO = "pvp_neto";
export const NET_PRICE = "net_price";
export const LIST_PRICE = "list_price";
export const STOCK = "stock";

//default props configuration
export const width = "100%";
export const height = "50px";
export const languageId = "en";
export const engineCodeName = "Web Code";
export const engineFamilyName = "all families";
export const searchFields = [];
export const exactSearch = false;
export const suggestionCodeFields = ["webcode"];
export const suggestionFamilyFields = [
  "ref1",
  "ref1f",
  "manufacturer",
  "autoname",
];
export const suggestionEnabled = true;
export const showAddToCart = true;
export const showAddToList = true;
export const showSearchButton = true;
export const showSelectButton = true;
export const showPlusQtyButton = true;
export const showPlusButton = false;
export const showWebCodeTab = true;
export const showLensIcon = false;
export const showMoreResults = true;
export const showSuggestionCombo = true;
export const selectorOnly = false;
export const openProduct = true;
export const openOn = "_blank";
export const searchTerm = "";
export const autocompleteMinimumCharacters = 2;
export const searchAsYouType = true;
export const elementId = 'appname';

export const onProductSelected = () => {
  return console.log("Product Selected...");
};
export const onDeleteProductCode = () => {
  return console.log("product deleted...");
};

export const onProductAddedToCart = (product) => {
  return console.log("Product Added to cart:");
};

export const onProductQtyModifiedOnCart = (product) => {
  return console.log("product qty changed");
};
export const onProductDeletedFromCart = (product) => {
  return console.log("product qty delete");
};

export const onProductAddedToList = (product) => {
  return console.log("product Added to List: ");
};

export const shouldClearFilters = true;
export const filterCharacters = ["-", ".", "*"];
export const numResults = 10;
export const resultsFields = [
  { key: "image", value: 1 },  
  { key: "manufacturer", value: 1 },
  { key: "reference", value: 1 },
  { key: "name", value: 1 },
  { key: "net_price", value: 1 }, 
  { key: "code", value:1},
  { key: "stock", value:1}
];
export const productSelectedField = "webcode";
export const filters = { all: [{ any: [{ not_discontinued: "true" }] }] };
